<template>
  <div v-cloak class="view-wrap">
    <div class="view-content">
        <div v-if="page === 'support-check'" class="support-check container text-center">
          <img class="support-bear" src="./images/support-bear.svg">
          <h3 class="h3">Are you sure you want to&nbsp;deactivate?</h3>
          <p>Is something not working? Our Support Bears are standing by and are
            pawing to make&nbsp;things&nbsp;right.</p>
          <a class="btn btn-lg" href="https://tunnelbear.com/support">Contact a Support Bear</a>
          <p>No thanks, just <a class="red-text" @click="deactivate">deactivate my team</a></p>
        </div>

        <div v-else-if="page === 'deactivate'" class="deactivate container">
          <div class="text-center">
            <img class="sad-bear" src="@/images/sadbear.svg">
            <h3 class="h3">Deactivate Team</h3>
            <p>Sorry to see you go, but we'll still be best friends forever.
              If you could tell us why you're deactivating, we'd really appreciate&nbsp;it.
            </p>
          </div>
          <div class="response-box">
            <p class="title"><strong>Please share your reason for&nbsp;leaving:</strong></p>
            <div class="radios custom">
              <label v-for="(reason, name) in reasons" v-bind:key="name">
                <span class="radio-check dot" :class="{'selected':  selectedReason === name}"></span>
                <input v-model="selectedReason" type="radio" name="reason" :value="name">{{ reason.copy }}
              </label>
            </div>
            <div v-if="selectedReason && reasons[selectedReason].followup" class="message-wrap">
              <p><strong>{{reasons[selectedReason].followup}}</strong></p>
              <textarea v-model="comments"></textarea>
              <div v-if="comments.length > 0" class="text-center btn-wrap">
                <button class="red btn-lg" @click="zapBear">Deactivate Team</button>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="page === 'zap-bear'" class="container text-center">
          <h1>Say Goodbye.</h1>
          <downgrade-animation class="zap-animation" ref="animation" @animationComplete="successfulDowngrade" @cancelDowngrade="secondChance"></downgrade-animation>
          <div v-if="downgradeSuccess" class="downgrade-finish">
            <h4>Downgrade successful!</h4>
            <p v-if="fullVersionUntil">Your team will still have unlimited tunneling until {{fullVersionUntil}}</p>
            <p>Go to <router-link :to="{ name: 'overview'}">my account.</router-link></p>
          </div>
          <div v-else-if="downgradeSuccess === false" class="downgrade-finish">
            <h4>Grr... something went wrong. Please&nbsp;try&nbsp;again.</h4>
          <p>Go to <router-link :to="{ name: 'overview'}">my account.</router-link></p>
          </div>
        </div>

        <div v-else class="saved text-center">
          <h2>Downgrade Cancelled!</h2>
          <img class="saved-bear" src="./images/savedbear.png">
          <p>You've rescued your Team from the terrible effects of our shrink ray! Rawr!</p>
          <p>Go to <router-link :to="{ name: 'overview'}">my account.</router-link></p>
        </div>
    </div>
  </div>
</template>

<script>
import downgradeAnimation from '@/components/downgrade-animation/downgrade-animation'

export default {
  name: 'downgrade',
  components: {
    'downgrade-animation': downgradeAnimation
  },
  data () {
    return {
      page: 'support-check',
      selectedReason: '',
      comments: '',
      downgradeSuccess: undefined,
      reasons: {
        'broken': {
          key: 'TunnelBear isnt working properly for my team',
          copy: 'TunnelBear isn\'t working properly for my\xa0team',
          followup: 'What aspects weren\'t working for your\xa0team?'
        },
        'features': {
          key: 'TunnelBear doesnt have the features my team needs',
          copy: 'TunnelBear doesn\'t have the features my team\xa0needs',
          followup: 'What features were you looking\xa0for?'
        },
        'price': {
          key: 'We cant afford it / its too expensive',
          copy: 'We can\'t afford it / it\'s too\xa0expensive',
          followup: 'What price point would you\xa0prefer?'
        },
        'usage': {
          key: 'My team isnt using it enough',
          copy: 'My team isn\'t using it\xa0enough',
          followup: 'What was the team\'s main use for\xa0TunnelBear?'
        },
        'switch': {
          key: 'My team found a service we like better',
          copy: 'My team found a service we like\xa0better',
          followup: 'What do you like about\xa0them?'
        },
        'other': {
          key: 'Other',
          copy: 'Other',
          followup: 'Could you provide a bit more\xa0detail?'
        }
      }
    }
  },
  computed: {
    fullVersionUntil: function () {
      if (this.$store.teamData) {
        return this.$store.teamData.fullVersionUntil
      }
      return ''
    }
  },
  methods: {
    deactivate: function () {
      this.page = 'deactivate'
    },
    secondChance: function () {
      this.page = 'saved'
    },
    successfulDowngrade: function () {
      this.$http.post(this.ENV.paymentBaseUrl + '/team/cancel', {
        reason: '[Reason]' + this.reasons[this.selectedReason].key +
        ' [Comments] ' + this.comments
      }).then((response) => {
        this.downgradeSuccess = true
        this.$store.dispatch('getTeamData', true)
      }).catch(() => {
        this.downgradeSuccess = false
      })
    },
    zapBear: function () {
      this.page = 'zap-bear'
      window.scrollTo(0, 0)
      setTimeout(() => {
        this.$refs.animation.runAnimation(0, 'run')
        this.$refs.animation.runCountdown()
      }, 1000)
    }
  },
  watch: {
    'selectedReason': function () {
      this.comments = ''
    }
  }
}

</script>

<style scoped lang="stylus" src="./downgrade.styl">



// WEBPACK FOOTER //
// src/views/downgrade/downgrade.vue